import React from "react";
import SideBar from "./Navigation_Bar/sidebar";
import { Submenu } from "./Navigation_Bar/submenu";
import ExtraSubmenus from "./Navigation_Bar/ExtraSubmenus";
import SliderData from "./Slider/slider";
import CourseDisplay from "./course_tabs/tabs";
import Categories from "./categories/Categories";

const Wrapper = () => {
  return (
    <div>
      <SideBar />
      <Submenu />
      <ExtraSubmenus />
      <SliderData />
      <CourseDisplay/>
      <Categories/>
    </div>
  );
};

export default Wrapper;
